import { Routes } from '@angular/router';
import { RegisterWithPINComponent } from './outsight.component.module/register-with-pin.component';
import { NotFoundComponent } from './common.component.module/not-found.component';
import { RouteNames } from './route.name';
import { LoginComponent } from './common.component.module/login.component';
import { LogoutComponent } from './common.component.module/logout.component';
import { authKeycloakGuard } from './auth.module/auth-keycloak-guard';

export const routes: Routes = [

    // Lazy modules
    {
        path: RouteNames.KREDIT_PORTAL,
        canActivateChild: [authKeycloakGuard],
        loadChildren: () => import('./insight.component.module/insight.module').then(m => m.InsightModule)
    },
    {
        path: RouteNames.LOGIN,
        component: LoginComponent
    },
    {
        path: RouteNames.LOGOUT,
        component: LogoutComponent
    },
    {
        path: RouteNames.REGISTRATION,
        component: RegisterWithPINComponent
    },
    {
        path: RouteNames.REGISTRIERUNG,
        component: RegisterWithPINComponent
    },

    // General Redirections
    {
        path: RouteNames.START,
        redirectTo: RouteNames.KREDIT_PORTAL_COCKPIT,
        pathMatch: 'full'
    },
    {
        path: RouteNames.BASE,
        redirectTo: RouteNames.KREDIT_PORTAL_COCKPIT,
        pathMatch: 'full'
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];

